import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

export default function Step5Klaar({ aantal, totalGroepen, logoUrl }) {
  return (
    <Card className="p-8 text-center" data-testid="wizard-done">
      <div className="mx-auto w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mb-4">
        <Check className="h-8 w-8 text-emerald-600" />
      </div>
      <h2 className="text-2xl font-medium mb-2">Onboarding voltooid</h2>
      <p className="text-neutral-600 mb-4">
        {aantal} locaties en {totalGroepen} groepen zijn succesvol aangemaakt
        {logoUrl && " · logo opgeslagen in Object Storage"}.
      </p>
      <div className="flex justify-center gap-2 flex-wrap">
        <Button variant="outline" onClick={() => window.location.href = "/app/locaties"}
                data-testid="wizard-done-locaties">
          Bekijk locaties
        </Button>
        <Button variant="outline" onClick={() => window.location.href = "/app/instellingen"}
                data-testid="wizard-done-instellingen">
          Instellingen
        </Button>
        <Button style={{ background: "var(--sage)" }} className="text-white"
                onClick={() => window.location.href = "/app/dashboard"}
                data-testid="wizard-done-dashboard">
          Naar dashboard →
        </Button>
      </div>
    </Card>
  );
}
